<template>
  <modal v-bind="$attrs" v-on="$listeners" :title="getTitle">
    <template v-slot:body>
      <p>
        {{
          $t("organizations.users_section.modals.assign_license.message", {
            licenseDisplayName: licenseDisplayName,
            userDisplayName: userDisplayName,
          })
        }}
      </p>
    </template>
    <template v-slot:footer>
      <span class="dialog-footer">
        <primary-button
          class="confirm-delete"
          ref="submitEditOrganizationUserButton"
          @click.native="handleSubmit"
        >
          {{ $t("organizations.users_section.modals.assign_license.confirm") }}
        </primary-button>
        <tertiary-button @click.native="handleCancel">
          {{ $t("organizations.users_section.modals.assign_license.cancel") }}
        </tertiary-button>
      </span>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import { mapGetters } from "vuex";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import TertiaryButton from "@/components/common/buttons/TertiaryButton";

export default {
  props: {
    licenseDisplayName: {
      type: String,
    },
    userDisplayName: {
      type: String,
    },
  },
  components: {
    Modal,
    PrimaryButton,
    TertiaryButton,
  },
  data() {
    return {};
  },

  computed: {
    ...mapGetters("user", ["isElsaAdmin"]),
    getTitle() {
      return this.$t(
        "organizations.users_section.modals.assign_license.title",
        {
          licenseDisplayName: this.licenseDisplayName,
          userDisplayName: this.userDisplayName,
        }
      );
    },
  },
  methods: {
    handleSubmit() {
      this.$emit("closed");
      this.$emit("doAssignLicenseToStudent");
    },
    handleCancel() {
      this.$emit("closed");
      this.$emit("cancelAssignLicenseToStudent");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";
p {
  margin: 0;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  color: #eb5757;
}
.elsa-button.confirm-delete,
.elsa-button.confirm-delete:hover {
  background: $orange;
  border-radius: 8px;
}
.elsa-checkbox {
  display: inline-block !important;
}
</style>
